import { z } from 'zod';
const ENTITY_TYPES = [
    'EVENT',
    'VENUE',
    'VENDOR',
    'USER',
    'PHOTO',
    'EXPENSE',
    'DOCUMENT',
    'VENDOR_CATEGORY',
];
export const createEntityLinkSchema = z.object({
    sourceEntityType: z.enum(ENTITY_TYPES),
    sourceEntityId: z.string().uuid(),
    targetEntityType: z.enum(ENTITY_TYPES),
    targetEntityId: z.string().uuid(),
    linkType: z.string().min(1).max(50),
    metadata: z.record(z.unknown()).optional(),
    sortOrder: z.number().int().optional(),
});
export const updateEntityLinkSchema = z
    .object({
    metadata: z.record(z.unknown()).optional(),
    metadataPatch: z.record(z.unknown()).optional(),
    // The column is a 4-byte integer; anything wider is refused here rather
    // than by the database after part of the request was written.
    sortOrder: z.number().int().min(-2147483648).max(2147483647).optional(),
})
    .refine((body) => body.metadata === undefined || body.metadataPatch === undefined, {
    message: 'Send metadata or metadataPatch, not both.',
    path: ['metadataPatch'],
});
export const entityLinkQuerySchema = z.object({
    sourceEntityType: z.enum(ENTITY_TYPES).optional(),
    sourceEntityId: z.string().uuid().optional(),
    targetEntityType: z.enum(ENTITY_TYPES).optional(),
    targetEntityId: z.string().uuid().optional(),
    linkType: z.string().max(50).optional(),
});
//# sourceMappingURL=entity-link.js.map